
export const apiUrl = "https://stats.goptgc.com/public/api/";

export const sendRequest = async (data, _req) => {
  var formBody = [];
  for (var property in data) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(data[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  const resp = await fetch(apiUrl + _req, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    body: formBody,
  });
  return resp.json();
};

export const authRequestNb = async (_req) => {
  try {
    const resp = await fetch(apiUrl + _req, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
       
      },
    });
    return resp.json();
  } catch (err) {
    if (err) {
      // console.log(err.message);
    }
  }
};

export const authRequest = async (data, _req) => {
  var formBody = [];
  for (var property in data) {
    var encodedKey = encodeURIComponent(property);
    var encodedValue = encodeURIComponent(data[property]);
    formBody.push(encodedKey + "=" + encodedValue);
  }
  formBody = formBody.join("&");
  //console.log("formBody=>",formBody);
  //console.log("ses =>",JSON.parse(sessionStorage.getItem("user")));
  try {
    const resp = await fetch(apiUrl + _req, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      },
      body: formBody,
    });
    return resp.json();
  } catch (err) {
    if (err) {
      // console.log(err.message);
    }
  }
};

export const sendFileRequest = async (data, _req) => {
  var myHeaders = new Headers();

  var formdata = new FormData();

  for (let i = 0; i < Object.keys(data).length; i++) {
    const singleData = data[Object.keys(data)[i]];
    formdata.append(Object.keys(data)[i], singleData);
  }

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  const res = await fetch(`${apiUrl}${_req}`, requestOptions);
  return res.json();
};
export const sendFileRequestWithProgress = async (data, _req) => {
  var myHeaders = new Headers();
  

  var formdata = new FormData();

  for (let i = 0; i < Object.keys(data).length; i++) {
    const singleData = data[Object.keys(data)[i]];
    formdata.append(Object.keys(data)[i], singleData);
  }

  // console.log(myHeaders, formdata, data);

  /* var requestOptions = {
    method: "post",
    url: `${apiUrl}${_req}`,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("user"))}`,
      Cookie: "ci_session=6777255e4b717ae7c32d79d8d3e04146ea6ae7b4",
    },
    body: formdata,
    redirect: "follow",
  }; */

  // const res = await axios(requestOptions);
  // console.log(res)
  // return res;
};

export const sendGetRequest = async (_req,method="POST") => {
  const resp = await fetch(apiUrl + _req, {
    method: method,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
      Cookie: "ci_session=9d575402035edfbb8df618ba3f668b47143df28b",
    },
  });
  return resp.json();
};

export const allLetter = (inputtxt) => {
  var letters = /^[a-zA-Z '.-]*$/;
  if (inputtxt.match(letters)) {
    return true;
  } else {
    return false;
  }
};

export const vpassword = (inputtxt) => {
  var letters =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{10,}$/;
  if (inputtxt.match(letters)) {
    return true;
  } else {
    return false;
  }
};
export const alphanumeric = (inputtxt) => {
  var letters = /^[A-Z0-9_]*$/;
  if (inputtxt.match(letters)) {
    return true;
  } else {
    return false;
  }
};
export const numeric = (inputtxt) => {
  var digits = /^[0-9]*$/;
  if (inputtxt.match(digits)) {
    return true;
  } else {
    return false;
  }
};

export const vpancard = (inputtxt) => {
  var letters = /([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
  if (inputtxt.match(letters)) {
    return true;
  } else {
    return false;
  }
};

export const vadhar = (inputtxt) => {
  if (inputtxt.length === 12) {
    return true;
  } else {
    return false;
  }
};

export const vphone = (inputtxt) => {
  var letters = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  if (inputtxt.match(letters)) {
    return true;
  } else {
    return false;
  }
};
export const vIndiaphone = (inputtxt) => {
  const mobileRegex = /^\+91[6-9]\d{9}$/;
  // const mobileRegex = /^\+[1-9]{1}[0-9]{1,3}[0-9]{7,15}$/;
  // Explanation:
  // ^\+          : Starts with a '+' for country code
  // [1-9]{1}     : First digit of the country code must be 1-9
  // [0-9]{1,3}   : 1 to 3 more digits for the country code
  // [0-9]{7,15}  : Mobile number with 7 to 15 digits
  // $            : End of the string
  return mobileRegex.test(inputtxt);
};
export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // Explanation:
  // ^          : Start of string
  // [^\s@]+    : One or more characters that are not a space or '@'
  // @          : The '@' symbol
  // [^\s@]+    : One or more characters that are not a space or '@'
  // \.         : A literal dot '.'
  // [^\s@]+    : One or more characters that are not a space or '@'
  // $          : End of string
  return emailRegex.test(email);
};
export const vcpassword = (p, inputtxt) => {
  if (p) {
    if (vpassword(p) && p.indexOf(inputtxt) >= 0 && p === inputtxt) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};
export const validateAadhar = (inputtxt) => {
  const aadharRegex = /^\d{12}$/; // Exactly 12 digits
  return aadharRegex.test(inputtxt);
};
export const validatePassport = (inputtxt) => {
  const passportRegex = /^[A-Z][0-9]{7}$/; // One uppercase letter followed by 7 digits
  return passportRegex.test(inputtxt);
};
export const validateDrivingLicence = (inputtxt) => {
  const dlRegex = /^[A-Z]{2}[0-9]{2}[ -]?[0-9]{6,7}$/; 
  // 2 uppercase letters for state code, 2 digits for RTO code, and 6-7 digits for unique number
  return dlRegex.test(inputtxt);
};
export const validateVoterID = (inputtxt) => {
  const voterIdRegex = /^[A-Z]{3}[0-9]{7}$/; // 3 uppercase letters followed by 7 digits
  return voterIdRegex.test(inputtxt);
};


export const userLogin = (_value) => {
  _value === false && sessionStorage.setItem("user", "");
  sessionStorage.setItem("isLogin", _value);
};

export const userFuncion = (_value) => {
  _value === false && sessionStorage.setItem("user", "");
  sessionStorage.setItem("isLogin", _value);
  window.dispatchEvent(new Event("storage"));
};



export const shorter = (num) => {
  const firstAddressPart = shortener(num, 0, 6);
  const lastAddressPart = shortener(num, 36, 42);
  return `${firstAddressPart}...${lastAddressPart}`;
};

export const shortener = (_data, _start, _end) => {
  let result = "";
  for (let i = _start; i < _end; i++) result = [...result, _data[i]];
  return result.join("");
};

export const contactPhoneCheck = (_no) => {
  if (_no.length > 6) {
    return true;
  } else {
    return false;
  }
};

export const mandsCheck = (_text) => {
  var letters = /^[a-zA-Z0-9 .,@]+$/;
  if (_text.match(letters)) {
    return true;
  } else {
    return false;
  }
};

let data = {};
let previousComparison = {};

export const isMax = (name, value) => {
  if (data.hasOwnProperty(name)) {
    if (data[name].length > 4) {
      data[name].shift();
    }
    let previousValue = data[name][data[name].length - 1];
    if (value > previousValue || value < previousValue) {
      let comparison = value > previousValue ? true : false;
      previousComparison[name] = comparison;
      data[name].push(value);
      return comparison;
    } else {
      return previousComparison[name];
    }
  } else {
    data[name] = [value];
    return true;
  }
};
//console.log("ues")
export const fixedNumber = (number, _length) => {
  if (number) {
    let str = number.toString();
    let decimalIndex = str.indexOf(".");
    if (str.split(".")[0].length >= _length) {
      return parseFloat(str).toFixed(2);
    } else {
      if (decimalIndex === -1) {
        str = str + ".00000000000000000000000";
      } else {
        str = str + "00000000000000000000000";
      }

      str = str.slice(0, _length);

      if (str[str.length - 1] === ".") {
        return str.slice(0, _length - 1);
      } else {
        return str;
      }
    }
  }
};

  export  const formatDate=(date, format = "yyyy-mm-dd") => {
    const d = new Date(date); // ensure it's a Date object

    if (isNaN(d)) return ""; // invalid date fallback
  
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const dd = String(d.getDate()).padStart(2, '0');
    const hh = String(d.getHours()).padStart(2, '0');
    const min = String(d.getMinutes()).padStart(2, '0');
    const ss = String(d.getSeconds()).padStart(2, '0');
  
    return format
      .replace("yyyy", yyyy)
      .replace("mm", mm)
      .replace("dd", dd)
      .replace("hh", hh)
      .replace("min", min)
      .replace("ss", ss);
  }
  export const formatVolume = (num) => {
    if (num === null || num === undefined || isNaN(num)) return "Vol. 0";
    if (num >= 1_000_000_000) return `Vol. ${(num / 1_000_000_000).toFixed(2)}B`;
    if (num >= 1_000_000)     return `Vol. ${(num / 1_000_000).toFixed(2)}M`;
    if (num >= 1_000)         return `Vol. ${(num / 1_000).toFixed(2)}K`;
    return `Vol. ${num}`;
  }
  export const formatLiquidity = (num) => {
    if (num === null || num === undefined || isNaN(num)) return "Liq. 0";
    if (num >= 1_000_000_000) return `Liq. ${(num / 1_000_000_000).toFixed(2)}B`;
    if (num >= 1_000_000)     return `Liq. ${(num / 1_000_000).toFixed(2)}M`;
    if (num >= 1_000)         return `Liq. ${(num / 1_000).toFixed(2)}K`;
    return `Liq. ${num}`;
  }
  
  export const formatNumber = (num) => {
    // 10 million = 10_000_000
    if (num >= 10_000_000) {
      if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + "B";
      return (num / 1_000_000).toFixed(1) + "M";
    }
    return num.toLocaleString(); 
  }
  
  
export const toFixed = (n, fixed) =>
  `${n}`.match(new RegExp(`^-?\\d+(?:\.\\d{0,${fixed}})?`))[0];

